// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1_uEb","footer":"ModalInfo_footer__2pK9A"};